import { render, staticRenderFns } from "./Serials.vue?vue&type=template&id=74629291&scoped=true"
import script from "./Serials.vue?vue&type=script&lang=js"
export * from "./Serials.vue?vue&type=script&lang=js"
import style0 from "./Serials.vue?vue&type=style&index=0&id=74629291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74629291",
  null
  
)

export default component.exports